<h1 mat-dialog-title>{{ title }}</h1>

<div mat-dialog-content>
  <form [formGroup]="form" class="tw-grid tw-grid-cols-2 tw-gap-4 tw-pt-2">

    <mat-form-field appearance="outline">
      <mat-label>Fecha</mat-label>
      <input matInput formControlName="fecha" type="date" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Turno</mat-label>
      <mat-select formControlName="shiftId" cdkFocusInitial>
        <mat-option *ngFor="let op of shifts" [value]="op.id">{{ op.title }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="tw-col-span-2">
      <mat-label>Scrap generado por</mat-label>
      <mat-select formControlName="operatorId">
        <mat-option>
          <ngx-mat-select-search
            formControlName="searchOperator"
            placeholderLabel="Buscar..."
            noEntriesFoundLabel="Sin resultados">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let op of operators$ | async" [value]="op.id">
          {{ op.fullName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="tw-col-span-2">
      <mat-label>Máquina</mat-label>
      <mat-select formControlName="machineId">
        <mat-option>
          <ngx-mat-select-search
            formControlName="searchMachine"
            placeholderLabel="Buscar..."
            noEntriesFoundLabel="Sin resultados">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let m of machines$ | async" [value]="m.id">
          {{ m.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Cantidad liberada</mat-label>
      <input formControlName="quantity" matInput type="number" required [max]="maxQuantity"  [min]="0"/>
      <mat-hint>Máximo: {{ maxQuantity }}</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Cantidad de Scrap</mat-label>
      <input formControlName="scrap" matInput type="number" [min]="0"/>
    </mat-form-field>

    <div class="tw-col-span-2">
      <app-form-scrap-reasons
        [class.tw-hidden]="!showReasons"
      ></app-form-scrap-reasons>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button (click)="onClickClose()" mat-button>Cerrar</button>
  <button
    (click)="onClickSave()"
    [disabled]="!form.valid || disable"
    mat-raised-button
    color="primary">
    Guardar cambios
  </button>
</div>
